import { parsePhoneNumber } from 'libphonenumber-js';
import IMask from 'imask';
import ru from 'date-fns/locale/ru';
import format from 'date-fns/format';
import { isEqualWith, isObject, isFunction, isEqual, differenceWith, difference, isBoolean, isSafeInteger } from 'lodash';

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function joinWords(separator) {
  for (var _len = arguments.length, words = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    words[_key - 1] = arguments[_key];
  }

  return words.filter(function (word) {
    return !!word;
  }).join(separator);
}
function formatOrganisationForm(str) {
  if (!str) {
    return '';
  }

  return str.replace(/Обществ[оа] с ограниченной ответственностью/gi, 'ООО').replace(/Закрытое акционерное общество/gi, 'ЗАО').replace(/Публичное акционерное общество/gi, 'ПАО').replace(/Открытое Акционерное общество/gi, 'ОАО').replace(/Акционерное общество/gi, 'АО');
}
function parseRuPhoneNumber(phone) {
  try {
    var phoneWithoutRuCountryCode = phone.startsWith('7') && phone.length === 11 ? phone.slice(1) : phone;
    var parsed = parsePhoneNumber(phoneWithoutRuCountryCode, 'RU').number;

    if (!parsed.startsWith('+7') || parsed.length !== 12) {
      return null;
    }

    return parsed;
  } catch (e) {
    return null;
  }
}
function formatPhoneNumber(phone) {
  if (!phone) {
    return '';
  }

  var rawPhone = _typeof(phone) === 'object' ? phone.number : phone;

  if (!rawPhone) {
    return '';
  }

  var extRaw = _typeof(phone) === 'object' ? phone.ext : '';
  var ext = extRaw ? "\u0434\u043E\u0431 ".concat(extRaw) : '';
  var parsedPhone = parseRuPhoneNumber(rawPhone);

  try {
    return joinWords(' ', parsedPhone ? IMask.pipe(parsedPhone, {
      mask: '+{7} (000) 000-00-00'
    }) : rawPhone, ext);
  } catch (e) {
    return joinWords(' ', rawPhone, ext);
  }
}
var validateEmail = function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

var numberWithSpaces = function numberWithSpaces(value) {
  var minimumFractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var maximumFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (value === null || value === undefined) {
    return '';
  }

  var parsedValue = Number(value);
  return new Intl.NumberFormat('ru-RU', {
    maximumFractionDigits: maximumFractionDigits < minimumFractionDigits ? minimumFractionDigits : maximumFractionDigits,
    minimumFractionDigits: minimumFractionDigits
  }).format(parsedValue);
};
function abbreviateNumber(value) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var POSTFIXES = ['', 'к', 'м', 'мд', 'T', 'P', 'E'];
  var sign = Math.sign(value) >= 0;
  value = Math.abs(value);
  var tier = Math.log10(value) / 3 | 0;

  if (tier === 0) {
    return (!sign ? '-' : '') + value.toString();
  }

  var suffix = POSTFIXES[tier];
  if (!suffix) throw new RangeError();
  var scale = Math.pow(10, tier * 3);
  var scaled = value / scale;
  var rounded = scaled.toFixed(precision);
  return (!sign ? '-' : '') + rounded + suffix;
}
function round(value, precision) {
  return Number(value).toFixed(precision);
}

function formatDate(date) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dd.MM.yyyy, HH:mm';

  if (!date) {
    return '';
  }

  if (typeof date === 'string' || typeof date === 'number') {
    date = new Date(date);
  }

  return format(date, dateFormat, {
    locale: ru
  });
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function bindAllMethods(obj) {
  var bindObj = Object.fromEntries(Object.entries(obj).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    var bindValue = value instanceof Function ? value.bind(obj) : value;
    return [key, bindValue];
  }));
  return bindObj;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function isEqualFormValues(oldValue, newValue) {
  return isEqualWith(oldValue, newValue, function (a, b) {
    if (!isObject(a) || !isObject(b) || isFunction(a) && isFunction(b)) {
      return isEqual(a, b);
    }

    if (Array.isArray(a) && Array.isArray(b)) {
      return !differenceWith(a, b, isEqualFormValues).length && !differenceWith(b, a, isEqualFormValues).length;
    }

    if (isObject(a) && isObject(b)) {
      var objA = a;
      var objB = b;
      var keysA = Object.keys(objA);
      var keysB = Object.keys(objB);

      if (keysA.length !== keysB.length || difference(keysA, keysB).length) {
        return false;
      }

      return keysA.every(function (key) {
        return isEqualFormValues(objA[key], objB[key]);
      });
    }

    return isEqual(a, b);
  });
}
function deleteEmptyFormValues(form) {
  var requiredFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Object.fromEntries(Object.entries(form).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return requiredFields.includes(key) || !!value || isBoolean(value) || isSafeInteger(value);
  }));
}
function formDifference(oldForm, newForm) {
  var requiredFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var keysOld = Object.keys(oldForm);
  var keysNew = Object.keys(newForm);
  var differentKeysOld = difference(keysOld, keysNew);
  var differentKeysNew = difference(keysNew, keysOld);
  var differentKeys = Array.from(new Set([].concat(_toConsumableArray(differentKeysOld), _toConsumableArray(differentKeysNew))));
  var oldObj = oldForm;
  var newObj = newForm;
  var changedKeys = keysOld.filter(function (key) {
    return !differentKeys.includes(key);
  }).reduce(function (keys, key) {
    return isEqualFormValues(oldObj[key], newObj[key]) ? keys : [].concat(_toConsumableArray(keys), [key]);
  }, []);
  var keys = Array.from(new Set([].concat(_toConsumableArray(differentKeys), _toConsumableArray(changedKeys), _toConsumableArray(requiredFields))));
  return Object.fromEntries(keys.filter(function (key) {
    return key in newObj;
  }).map(function (key) {
    return [key, newObj[key]];
  }));
}
function clearUnnecessaryPhoneExt(form) {
  var phoneFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Object.fromEntries(Object.entries(form).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    if (!value || !phoneFields.includes(key)) {
      return [key, value];
    }

    return [key, {
      number: value.number,
      ext: value.number ? value.ext : ''
    }];
  }));
}
function confirmFormLeaving() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Имеются несохраненные данные, они будут утеряны. Вы уверены, что хотите выйти из режима редактирования?';
  // eslint-disable-next-line no-alert
  return window.confirm(message);
}

export { abbreviateNumber, bindAllMethods, clearUnnecessaryPhoneExt, confirmFormLeaving, deleteEmptyFormValues, formDifference, formatDate, formatOrganisationForm, formatPhoneNumber, isEqualFormValues, joinWords, numberWithSpaces, parseRuPhoneNumber, round, validateEmail };
